<!-- <main class="register-page">
  <section class="left">
    <a routerLink="/" class="logo">
      MeuCardápio
    </a>

    <h1>Crie seu cardápio digital grátis</h1>

    <p>
      Cadastre seu restaurante, gere seu link online
      e comece a receber pedidos pelo WhatsApp.
    </p>

    <ul>
      <li>Cardápio online responsivo</li>
      <li>Link próprio para divulgar</li>
      <li>QR Code para mesas</li>
      <li>Painel para gerenciar produtos</li>
    </ul>
  </section>

  <section class="form-card">
    <h2>Criar conta</h2>

    <p class="subtitle">
      Preencha os dados abaixo para começar.
    </p>

    <label for="name">
      Seu nome
    </label>

    <input
      id="name"
      name="name"
      [(ngModel)]="form.name"
      type="text"
      placeholder="Ex: Bárbara"
      autocomplete="name"
      [disabled]="loading"
    >

    <label for="email">
      E-mail
    </label>

    <input
      id="email"
      name="email"
      [(ngModel)]="form.email"
      type="email"
      placeholder="seuemail@email.com"
      autocomplete="email"
      [disabled]="loading"
    >

    <label for="password">
      Senha
    </label>

    <input
      id="password"
      name="password"
      [(ngModel)]="form.password"
      type="password"
      placeholder="Crie uma senha"
      autocomplete="new-password"
      [disabled]="loading"
    >

    <label for="restaurantName">
      Nome do restaurante
    </label>

    <input
      id="restaurantName"
      name="restaurantName"
      type="text"
      [ngModel]="form.restaurantName"
      (ngModelChange)="onRestaurantNameChange($event)"
      placeholder="Ex: Pizzaria Central"
      autocomplete="organization"
      [disabled]="loading"
    >

    <label for="restaurantSlug">
      Endereço do seu cardápio
    </label>

    <div
      class="domain-field"
      [class.domain-field-error]="
        slugError && !checkingSlug
      "
      [class.domain-field-success]="
        slugAvailable === true && !checkingSlug
      "
    >
      <span class="domain-prefix">
        https://
      </span>

      <input
        id="restaurantSlug"
        name="restaurantSlug"
        type="text"
        [ngModel]="form.restaurantSlug"
        (ngModelChange)="onSlugChange($event)"
        placeholder="pizzaria-central"
        maxlength="50"
        spellcheck="false"
        autocomplete="off"
        [disabled]="loading"
      >

      <span class="domain-suffix">
        .{{ platformDomain }}
      </span>
    </div>

    <div
      class="domain-status checking-message"
      *ngIf="checkingSlug"
    >
      Verificando disponibilidade...
    </div>

    <div
      class="domain-status success-message"
      *ngIf="
        form.restaurantSlug &&
        slugAvailable === true &&
        !checkingSlug
      "
    >
      <span>
        ✓ Endereço disponível
      </span>

      <strong>
        https://{{ form.restaurantSlug }}.{{ platformDomain }}
      </strong>
    </div>

    <div
      class="domain-status error-message"
      *ngIf="
        slugError &&
        !checkingSlug
      "
    >
      {{ slugError }}
    </div>

    <div
      class="slug-suggestions"
      *ngIf="
        slugSuggestions.length > 0 &&
        !checkingSlug
      "
    >
      <span class="suggestions-title">
        Sugestões disponíveis:
      </span>

      <button
        type="button"
        class="suggestion-button"
        *ngFor="let suggestion of slugSuggestions"
        (click)="selectSlugSuggestion(suggestion)"
        [disabled]="loading"
      >
        {{ suggestion.slug }}.{{ platformDomain }}
      </button>
    </div>

    <label for="whatsapp">
      WhatsApp do restaurante
    </label>

    <input
      id="whatsapp"
      name="whatsapp"
      [(ngModel)]="form.whatsapp"
      type="tel"
      inputmode="numeric"
      placeholder="Ex: 5581999999999"
      autocomplete="tel"
      [disabled]="loading"
    >

    <button
      type="button"
      class="register-button"
      [disabled]="
        loading ||
        checkingSlug ||
        slugAvailable === false
      "
      (click)="register()"
    >
      {{
        loading
          ? 'Criando conta...'
          : checkingSlug
            ? 'Verificando endereço...'
            : 'Criar meu cardápio'
      }}
    </button>

    <div
      class="error"
      *ngIf="error"
    >
      {{ error }}
    </div>

    <p class="login">
      Já tem conta?

      <a routerLink="/login">
        Entrar
      </a>
    </p>
  </section>
</main> -->



<main class="register-page">

  <!-- =========================================
       LATERAL ESQUERDA
       ========================================= -->

  <section class="register-showcase">

    <div class="showcase-decoration decoration-one"></div>
    <div class="showcase-decoration decoration-two"></div>

    <div class="showcase-content">

      <a
        routerLink="/"
        class="brand"
      >
        <span class="brand-icon">
          🍽️
        </span>

        <span>
          MeuCardápio
        </span>
      </a>


      <div class="showcase-text">

        <span class="showcase-badge">
          Comece gratuitamente
        </span>

        <h1>
          Transforme seu restaurante com um cardápio digital.
        </h1>

        <p>
          Crie seu cardápio, divulgue seu link e comece
          a receber pedidos de forma simples e profissional.
        </p>

      </div>


      <div class="benefits">

        <div class="benefit-item">

          <span class="benefit-check">
            ✓
          </span>

          <div>
            <strong>
              Cardápio online responsivo
            </strong>

            <span>
              Perfeito em celulares, tablets e computadores.
            </span>
          </div>

        </div>


        <div class="benefit-item">

          <span class="benefit-check">
            ✓
          </span>

          <div>
            <strong>
              Seu próprio endereço
            </strong>

            <span>
              Tenha um link exclusivo para divulgar seu restaurante.
            </span>
          </div>

        </div>


        <div class="benefit-item">

          <span class="benefit-check">
            ✓
          </span>

          <div>
            <strong>
              QR Code para suas mesas
            </strong>

            <span>
              Seus clientes acessam o cardápio rapidamente.
            </span>
          </div>

        </div>

      </div>

    </div>


    <!-- MOCKUP -->

    <div class="showcase-preview">

      <div class="floating-card floating-orders">

        <span class="floating-icon">
          🧾
        </span>

        <div>
          <strong>
            Novo pedido
          </strong>

          <small>
            Pedido #1042 recebido
          </small>
        </div>

      </div>


      <div class="phone">

        <div class="phone-speaker"></div>

        <div class="phone-screen">

          <div class="restaurant-cover">

            <div class="restaurant-logo">
              🍕
            </div>

          </div>


          <div class="restaurant-info">

            <div>
              <h3>
                Seu Restaurante
              </h3>

              <p>
                Seu cardápio digital
              </p>
            </div>

            <span class="open-badge">
              Aberto
            </span>

          </div>


          <div class="fake-search">
            🔍 Buscar no cardápio
          </div>


          <div class="fake-categories">

            <span class="active">
              Destaques
            </span>

            <span>
              Bebidas
            </span>

            <span>
              Combos
            </span>

          </div>


          <article class="fake-product">

            <div class="fake-product-image">
              🍕
            </div>

            <div class="fake-product-content">

              <strong>
                Produto especial
              </strong>

              <small>
                Uma deliciosa opção do seu cardápio
              </small>

              <div class="fake-product-footer">

                <b>
                  R$ 39,90
                </b>

                <span>
                  +
                </span>

              </div>

            </div>

          </article>


          <article class="fake-product">

            <div class="fake-product-image">
              🍔
            </div>

            <div class="fake-product-content">

              <strong>
                Combo da casa
              </strong>

              <small>
                Uma combinação especial
              </small>

              <div class="fake-product-footer">

                <b>
                  R$ 32,90
                </b>

                <span>
                  +
                </span>

              </div>

            </div>

          </article>

        </div>

      </div>


      <div class="floating-card floating-link">

        <span class="floating-icon">
          🔗
        </span>

        <div>
          <strong>
            Link exclusivo
          </strong>

          <small>
            Pronto para compartilhar
          </small>
        </div>

      </div>

    </div>

  </section>


  <!-- =========================================
       FORMULÁRIO
       ========================================= -->

  <section class="form-section">

    <div class="form-card">

      <div class="form-header">

        <span class="form-label">
          Comece agora
        </span>

        <h2>
          Criar conta
        </h2>

        <p class="subtitle">
          Preencha os dados abaixo para criar seu cardápio.
        </p>

      </div>


      <!-- NOME -->

      <div class="form-group">

        <label for="name">
          Seu nome
        </label>

        <input
          id="name"
          name="name"
          [(ngModel)]="form.name"
          type="text"
          placeholder="Ex: Bárbara"
          autocomplete="name"
          [disabled]="loading"
        >

      </div>


      <!-- EMAIL -->

      <div class="form-group">

        <label for="email">
          E-mail
        </label>

        <input
          id="email"
          name="email"
          [(ngModel)]="form.email"
          type="email"
          placeholder="seuemail@email.com"
          autocomplete="email"
          [disabled]="loading"
        >

      </div>


      <!-- SENHAS -->

      <div class="password-grid">

        <div class="form-group">

          <label for="password">
            Senha
          </label>

          <div
            class="password-wrapper"
            [class.input-error]="passwordError"
          >

            <input
              id="password"
              name="password"
              [(ngModel)]="form.password"
              [type]="showPassword ? 'text' : 'password'"
              placeholder="Crie uma senha"
              autocomplete="new-password"
              [disabled]="loading"
              (ngModelChange)="validatePasswords()"
            >

            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [disabled]="loading"
              [attr.aria-label]="
                showPassword
                  ? 'Ocultar senha'
                  : 'Mostrar senha'
              "
            >

              <svg
                *ngIf="!showPassword"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"
                ></path>

                <circle
                  cx="12"
                  cy="12"
                  r="3"
                ></circle>
              </svg>

              <svg
                *ngIf="showPassword"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M3 3l18 18"></path>

                <path
                  d="M10.6 5.2A9.7 9.7 0 0 1 12 5c6.5 0 10 7 10 7a15.6 15.6 0 0 1-2.1 3.1"
                ></path>

                <path
                  d="M6.6 6.6C3.6 8.6 2 12 2 12s3.5 7 10 7a9.8 9.8 0 0 0 5.4-1.6"
                ></path>

                <path
                  d="M9.9 9.9a3 3 0 0 0 4.2 4.2"
                ></path>

              </svg>

            </button>

          </div>

        </div>


        <div class="form-group">

          <label for="confirmPassword">
            Confirmar senha
          </label>

          <div
            class="password-wrapper"
            [class.input-error]="passwordError"
          >

            <input
              id="confirmPassword"
              name="confirmPassword"
              [(ngModel)]="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'"
              placeholder="Digite novamente"
              autocomplete="new-password"
              [disabled]="loading"
              (ngModelChange)="validatePasswords()"
            >

            <button
              type="button"
              class="password-toggle"
              (click)="toggleConfirmPasswordVisibility()"
              [disabled]="loading"
              [attr.aria-label]="
                showConfirmPassword
                  ? 'Ocultar senha'
                  : 'Mostrar senha'
              "
            >

              <svg
                *ngIf="!showConfirmPassword"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"
                ></path>

                <circle
                  cx="12"
                  cy="12"
                  r="3"
                ></circle>
              </svg>

              <svg
                *ngIf="showConfirmPassword"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M3 3l18 18"></path>

                <path
                  d="M10.6 5.2A9.7 9.7 0 0 1 12 5c6.5 0 10 7 10 7a15.6 15.6 0 0 1-2.1 3.1"
                ></path>

                <path
                  d="M6.6 6.6C3.6 8.6 2 12 2 12s3.5 7 10 7a9.8 9.8 0 0 0 5.4-1.6"
                ></path>

                <path
                  d="M9.9 9.9a3 3 0 0 0 4.2 4.2"
                ></path>

              </svg>

            </button>

          </div>

        </div>



<div class="password-requirements">

  <span
    [class.valid]="
      form.password.length >= 8
    "
  >
    ✓ 8 caracteres
  </span>

  <span
    [class.valid]="
      hasUppercase()
    "
  >
    ✓ Letra maiúscula
  </span>

  <span
    [class.valid]="
      hasLowercase()
    "
  >
    ✓ Letra minúscula
  </span>

  <span
    [class.valid]="
      hasNumber()
    "
  >
    ✓ Número
  </span>

  <span
    [class.valid]="
      hasSpecialCharacter()
    "
  >
    ✓ Caractere especial
  </span>

</div>

      </div>


      <div
        class="field-error"
        *ngIf="passwordError"
      >
        {{ passwordError }}
      </div>


      <div
        class="password-success"
        *ngIf="
          confirmPassword &&
          !passwordError &&
          form.password
        "
      >
        ✓ As senhas coincidem
      </div>


      <!-- RESTAURANTE -->

      <div class="form-group">

        <label for="restaurantName">
          Nome do restaurante
        </label>

        <input
          id="restaurantName"
          name="restaurantName"
          type="text"
          [ngModel]="form.restaurantName"
          (ngModelChange)="onRestaurantNameChange($event)"
          placeholder="Ex: Pizzaria Central"
          autocomplete="organization"
          [disabled]="loading"
        >

      </div>


      <!-- ENDEREÇO -->

      <div class="form-group">

        <label for="restaurantSlug">
          Endereço do seu cardápio
        </label>

        <div
          class="domain-field"
          [class.domain-field-error]="
            slugError && !checkingSlug
          "
          [class.domain-field-success]="
            slugAvailable === true &&
            !checkingSlug
          "
        >

          <span class="domain-prefix">
            https://
          </span>

          <input
            id="restaurantSlug"
            name="restaurantSlug"
            type="text"
            [ngModel]="form.restaurantSlug"
            (ngModelChange)="onSlugChange($event)"
            placeholder="pizzaria-central"
            maxlength="50"
            spellcheck="false"
            autocomplete="off"
            [disabled]="loading"
          >

          <span class="domain-suffix">
            .{{ platformDomain }}
          </span>

        </div>


        <div
          class="domain-status checking-message"
          *ngIf="checkingSlug"
        >
          Verificando disponibilidade...
        </div>


        <div
          class="domain-status success-message"
          *ngIf="
            form.restaurantSlug &&
            slugAvailable === true &&
            !checkingSlug
          "
        >
          <span>
            ✓ Endereço disponível
          </span>

          <strong>
            https://{{ form.restaurantSlug }}.{{ platformDomain }}
          </strong>
        </div>


        <div
          class="domain-status error-message"
          *ngIf="
            slugError &&
            !checkingSlug
          "
        >
          {{ slugError }}
        </div>


        <div
          class="slug-suggestions"
          *ngIf="
            slugSuggestions.length > 0 &&
            !checkingSlug
          "
        >

          <span class="suggestions-title">
            Sugestões disponíveis:
          </span>

          <button
            type="button"
            class="suggestion-button"
            *ngFor="let suggestion of slugSuggestions"
            (click)="selectSlugSuggestion(suggestion)"
            [disabled]="loading"
          >
            {{ suggestion.slug }}.{{ platformDomain }}
          </button>

        </div>

      </div>


      <!-- WHATSAPP -->
<!-- WHATSAPP -->

<div class="form-group">

  <label for="whatsapp">
    WhatsApp do restaurante
  </label>

<div class="phone-field">

  <span class="phone-prefix">
    <span class="country-code">
      +55
    </span>
  </span>

  <input
    id="whatsapp"
    name="whatsapp"
    type="tel"
    inputmode="numeric"
    [ngModel]="form.whatsapp"
    (ngModelChange)="onWhatsappChange($event)"
    placeholder="(81) 99999-9999"
    autocomplete="tel"
    maxlength="15"
    [disabled]="loading"
  >

</div>

<small class="field-hint">
  Digite o DDD e o número do WhatsApp.
</small>

</div>

      <!-- ERRO GERAL -->

      <div
        class="error"
        *ngIf="error"
      >
        {{ error }}
      </div>


      <!-- CADASTRAR -->

      <button
        type="button"
        class="register-button"
        [disabled]="
          loading ||
          checkingSlug ||
          slugAvailable === false ||
          !!passwordError
        "
        (click)="register()"
      >
        {{
          loading
            ? 'Criando conta...'
            : checkingSlug
              ? 'Verificando endereço...'
              : 'Criar meu cardápio grátis'
        }}
      </button>


      <p class="login">
        Já tem uma conta?

        <a routerLink="/login">
          Entrar
        </a>
      </p>

    </div>

  </section>

</main>